import React from 'react'; // Import React library
import Sidebar from './sidebar'; // Import Sidebar component
import '../../assets/styles/layout.css'; // Import CSS for layout styles

// Define Layout component
const Layout = ({ children }) => {
  return (
    <div className="layout"> {/* Main layout container */}
      <Sidebar className="sidebar" /> {/* Sidebar component */}
      <main className="main-container"> {/* Main content container */}
        {children} {/* Render children components inside the main container */}
      </main>
    </div>
  );
};

// Export the Layout component
export default Layout;
